export type WebSocketTestMode = 'none' | 'block' | 'chaos';

export const useWebSocketTestMode = () => {
  if (import.meta.server) {
    return null;
  }

  const activeMode = ref<WebSocketTestMode>('none');
  const pusherConnection = usePusherConnection();

  const forceDisconnect = (autoReconnect = false) => {
    const pusher = pusherConnection?.pusher.value;
    if (!pusher) {
      return;
    }

    pusher.disconnect();

    if (autoReconnect) {
      setTimeout(() => pusher.connect(), 500);
    }
  };

  const clearAllChannels = () => {
    const pusher = pusherConnection?.pusher.value;
    if (!pusher) {
      return;
    }
    const channels = pusher.channels.all();
    for (const channel of channels) {
      pusher.unsubscribe(channel.name);
    }
  };

  const forceReconnect = () => {
    clearAllChannels();
    pusherConnection?.pusher.value?.connect();
  };

  const isBlockMode = computed(() => activeMode.value === 'block');
  const isChaosMode = computed(() => activeMode.value === 'chaos');

  const setMode = (mode: WebSocketTestMode) => {
    activeMode.value = mode;
  };

  return {
    activeMode: readonly(activeMode),
    isBlockMode,
    isChaosMode,
    setMode,
    forceDisconnect,
    clearAllChannels,
    forceReconnect,
    pusherConnection,
  };
};
